export enum purchaseOrderStatus {
  SUGGESTED = "SUGGESTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  GENERATED = "GENERATED",
  SENT = "SENT",
  NOT_COMPLETED = "NOT_COMPLETED",
  PARTIAL = "PARTIAL",
}
